import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService, DspxCardSetBaseFormComponent, FormNavigationService, SpinnerService } from 'dspx-core';
import { take } from 'rxjs';
import { API_ENDPOINTS } from '../../constants/api-endpoints.constants';
import { FORM_ACTIONS, FORM_CUSTOM_ACTIONS, QUESTION_CODES } from '../../constants/app-data.constants';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { TEMPLATES } from '../../constants/templates.constants';
import { AppDataService } from '../../services/app-data.service';
import { ExcelImportService } from '../../services/excel-import.service';
import { ResponseParserService } from '../../services/response-parser.service';
import { BaseCardSetListComponent } from "../base-card-set-list-component/base-card-set-list.component";

@Component({
  selector: 'app-reference-data-list',
  templateUrl: './reference-data-list.component.html',
  styleUrl: './reference-data-list.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ReferenceDataListComponent extends BaseCardSetListComponent implements OnInit, OnDestroy {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }
  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    protected excelImportService: ExcelImportService,
    private formNavigationService: FormNavigationService
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.referenceDataList,
      () => API_ENDPOINTS.dashboard.getReferenceDataCategories,
      false);
  }

  ngOnInit(): void {
    this.route.url.subscribe((url) => {
      if (url.length === 0) {
        // In the case where this component is being loaded as part of the default (empty) route, we want to force it
        // to the Reference Data List route so that the menu will highlight the selected option.
        this.router.navigate(['/', ROUTE_CONSTANTS.referenceData.list]);
       }
    });

    this.formNavigationService.onNavigation().subscribe(event => {
      setTimeout(() => {
        this.overrideHtmlTitleSetByDspxFramework();
      })
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
  }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    // No filters are implemented in this dashboard
  }

  dialogButtonClicked(event: any): void {
    // No dialog buttons are implemented in this dashboard
  }

  actionButtonClicked(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.referenceDataListForm.referenceDataPlaceholder: {
        switch (event.event.type) {
          case FORM_ACTIONS.referenceDataListForm.new: {
            this.router.navigate(['/', ROUTE_CONSTANTS.referenceData.prefix]);
            break;
          }
          case FORM_ACTIONS.referenceDataListForm.view:
          case FORM_ACTIONS.referenceDataListForm.edit: {
            this.router.navigate(['/', ROUTE_CONSTANTS.referenceData.prefix, event.event.data.id]);
            break;
          }
          case FORM_ACTIONS.referenceDataListForm.custom: {
            switch (event.event.data.buttonType) {
              case FORM_CUSTOM_ACTIONS.referenceDataListForm.bulkUpload: {
                const element = document.getElementById('fileInputRefData') as HTMLElement;
                element.click();
                break;
              }
            }
            break;
          }
        }
        break;
      }
    }
  }

  uploadReferenceData(event: any): void {
    this.registerSubscription(
      this.excelImportService.uploadReferenceData(event.target.files[0])
        .pipe(take(1))
        .subscribe(() => {
          this.loadGridData();
        })
    );
  }
}
